module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama_ekimae/yokohama_ekimae_concept_02-8639b180920d644c410c0eca0218a778.jpg";